import { useTranslation } from 'react-i18next';
import { FragmentType, gql, useFragment } from '@/__generated__';
import ChannelPostingTimes from '@/components/compound-components/settings/posts-tab/posting-times/channel-posting-times';
import { PostChannel } from '@/__generated__/graphql';

const PostingTimesFragment = gql(`
  fragment PostingTimesFragment on SchedulingVariantV1 {
    channels {
      channel
    }
    ...ChannelPostingTimesFragment
  }
`);

export default function PostingTimes({
  scheduleVariantValues,
}: {
  scheduleVariantValues: FragmentType<typeof PostingTimesFragment>;
}) {
  const { t } = useTranslation();
  const socialMediaPostingTimes = useFragment(
    PostingTimesFragment,
    scheduleVariantValues
  );

  return (
    <div>
      <h5 className='mb-0 mt-6 font-medium'>
        {t('post-client.posting-times')}
      </h5>
      {socialMediaPostingTimes?.channels?.map((postChannel) => (
        <ChannelPostingTimes
          key={postChannel.channel}
          channel={
            postChannel.channel as Exclude<PostChannel, PostChannel.Unspecified>
          }
          variant={socialMediaPostingTimes}
        />
      ))}
    </div>
  );
}
